export default __webpack_public_path__ + "static/media/pelis.01fe9ba1.png";